var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.175,
    height: 24.175,
    viewBox: "0 0 24.175 24.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Gas_pipe_577517",
    "data-name": "noun_Gas pipe_577517",
    transform: "translate(0.132 0.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(0.018 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M31.631,24.311a.4.4,0,0,1-.286-.674l2.214-2.29a.4.4,0,1,1,.572.553l-2.214,2.29a.4.4,0,0,1-.286.121",
    transform: "translate(-18.812 -12.781)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M27.609,26.8a.8.8,0,1,0,.8.8.8.8,0,0,0-.8-.8m0,2.387A1.592,1.592,0,1,1,29.2,27.6a1.593,1.593,0,0,1-1.592,1.592",
    transform: "translate(-15.672 -15.658)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M23.846,24.317a.4.4,0,0,1-.287-.122l-2.208-2.3a.4.4,0,0,1,.574-.552l2.208,2.3a.4.4,0,0,1-.287.674",
    transform: "translate(-12.795 -12.781)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M33.787,34.171a.4.4,0,0,1-.281-.117L31.255,31.8a.4.4,0,1,1,.563-.563l2.251,2.251a.4.4,0,0,1-.281.679",
    transform: "translate(-18.755 -18.741)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M21.637,34.171a.4.4,0,0,1-.281-.679l2.251-2.251a.4.4,0,1,1,.563.563l-2.251,2.251a.4.4,0,0,1-.281.117",
    transform: "translate(-12.795 -18.741)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M.814,38.135H3.2v-8.4a1.549,1.549,0,0,1,1.547-1.547H7.334a4.7,4.7,0,0,1,0-2.387H3.6A2.789,2.789,0,0,0,.814,28.585Zm2.785.8H.416a.4.4,0,0,1-.4-.4V28.585A3.585,3.585,0,0,1,3.6,25H7.881a.4.4,0,0,1,.37.543,3.933,3.933,0,0,0,0,2.894.4.4,0,0,1-.37.543H4.748A.752.752,0,0,0,4,29.734v8.8a.4.4,0,0,1-.4.4Z",
    transform: "translate(-0.018 -15.056)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M40.2,13.135h3.735a2.789,2.789,0,0,0,2.785-2.785V.8H44.334V9.2a1.549,1.549,0,0,1-1.547,1.547H40.2a4.7,4.7,0,0,1,0,2.387m3.735.8H39.654a.4.4,0,0,1-.371-.543,3.928,3.928,0,0,0,0-2.894.4.4,0,0,1,.371-.543h3.133a.752.752,0,0,0,.751-.751V.4a.4.4,0,0,1,.4-.4h3.183a.4.4,0,0,1,.4.4v9.948a3.585,3.585,0,0,1-3.581,3.581",
    transform: "translate(-23.642 -0.004)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M22.793,18.8a3.979,3.979,0,1,0,3.979,3.979A3.984,3.984,0,0,0,22.793,18.8m0,8.754a4.775,4.775,0,1,1,4.775-4.775,4.78,4.78,0,0,1-4.775,4.775",
    transform: "translate(-10.855 -10.841)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.b41513b146a4ad9e9528285988b15b77.svg";
export { ForwardRef as ReactComponent };